<template>
  <div style="overflow-x: auto; width: 100%; height: 100%;">
    <drop-list
      :items="documentNotes"
      class="list"
      :accepts-type="['panel', 'item']"
      :row="true"
      @insert=""
      @reorder=""
    >
      <template v-slot:item="{ item }">
        <drag
          class="item pr-2 pa-1"
          :key="item.id"
          type="panel"
          style="display: inline-block; width: 401px;"
        >
          <note-page
            :colIndex="colIndex"
            :key="item.id"
            :pageId="item.pageId"
            :dashboardView="false"
            :pinned="true"
            :nestedPage="true"
            class="white mb-4"
            :showToolbar="false"
            style=""
            @close=""
            @expand=""
            @toggleLock=""
          ></note-page>
          <template v-slot:drag-image>
            <div class="blue lighten-4" style="opactiy: 0.5; height: 100px; width: 300px;"></div>
          </template>
        </drag>
      </template>
    </drop-list>
  </div>
  <!-- <grid-layout
    :layout="boardPages"
    :col-num="12"
    :row-height="30"
    :is-draggable="true"
    :is-resizable="true"
    :is-mirrored="false"
    :vertical-compact="true"
    :margin="[10, 10]"
    :use-css-transforms="true"
    width="100%"
    @layout-updated="updateGrid"
  >
    <grid-item
      class="elevation-2 white"
      v-for="item in boardPages"
      :x="item.x"
      :y="item.y"
      :w="item.w"
      :h="item.h"
      :i="item.i"
      :key="item.page.value.id"
    >
      <context-doc
        :ref="item.noteId"
        :page="item.page.value"
        :dashboardView="false"
        :gridView="true"
        :parentPageId="page.id"
        :pinned="false"
        :noteId="item.noteId"
        :allowQuoteAttr="false"
        :nested="true"
        @traverseLeaveUp=""
        @traverseLeaveDown=""
      >
      </context-doc>
    </grid-item> -->
  <!-- </grid-layout> -->
</template>

<script>
import { Drag, DropList } from 'vue-easy-dnd';
// import { Container, Draggable } from 'vue-smooth-dnd';
// import { GridLayout, GridItem } from 'vue-grid-layout';
import { computed, inject, ref, watch, onMounted } from '@vue/composition-api';
// import NotePage from '@/views/Context/components/ContentSection/NotePage';

export default {
  components: {
    Drag,
    DropList,
    'note-page': () => import('@/views/Context/components/ContentSection/NotePage')
  },
  props: ['page', 'noteId'],
  setup(props) {
    const page = props.page;
    console.log(page);
    const documentNotes = computed(() => {
      // console.log('compute doc notes from contextdoc');
      if (props.page) {
        return Object.values(props.page.pageNotes)
          .filter(n => !n.toDelete && n !== undefined && n != null && n.id)
          .sort((a, b) => (a.order > b.order ? 1 : -1));
        // .map(n => ({ pageId: n.pageId, type: n.type, text: n.content.html }));
      } else {
        return [];
      }
    });

    const colIndex = inject('colIndex');
    // const boardPages = ref([]);
    // const updateBoardPages = () => {
    //   console.log('update board pages');
    //   // const notes = Object.values(page.value.pageNotes).filter(n => {
    //   //   return n.id !== undefined && !n.toDelete;
    //   // });
    //   // console.log(notes);
    //   const noGridData = [];
    //   const pagesArray = [];

    //   documentNotes.value.forEach(n => {
    //     // if (n.gridData) {
    //     // const { x, y, h, w, i } = n.gridData;
    //     pagesArray.push({
    //       page: pages[n.pageId],
    //       noteId: n.id
    //       // x,
    //       // y,
    //       // i,
    //       // w,
    //       // h
    //     });
    //     // } else {
    //     //   console.log('no grid data', n);
    //     //   noGridData.push(n);
    //     // }
    //     // const y = Math.floor(n.order / 3);
    //     // const x = n.order - y * 3;
    //     // return { page: pages[n.pageId], noteId: n.id, x: x * 4, y: y * 6, i: n.order, w: 4, h: 6 };
    //   });
    //   // if (noGridData.length) {
    //   //   //  we have some items that need coordinates
    //   //   noGridData.forEach(n => {
    //   //     pagesArray.push({
    //   //       page: pages[n.pageId],
    //   //       noteId: n.id,
    //   //       x: (pagesArray.length * 3) % 12,
    //   //       y: pagesArray.length + 12, // puts it at the bottom
    //   //       w: 3,
    //   //       h: 5,
    //   //       i: pagesArray.length
    //   //     });
    //   //   });
    //   // }
    //   console.log(pagesArray);
    //   boardPages.value = pagesArray;
    // };
    // watch(() => props.page.pageNotes, updateBoardPages);
    // watch(
    //   () => props.page.id,
    //   (n, o) => {
    //     console.log('page updated');
    //     if (n.id !== o.id) {
    //       updateBoardPages();
    //     }
    //   }
    // );
    // onMounted(updateBoardPages);
    // const boardPages = computed(() => {
    //   const notes = computed(() =>
    //     Object.values(props.page.pageNotes).filter(n => {
    //       return n.id !== undefined && !n.toDelete;
    //     })
    //   );
    //   return notes.value.map(n => {
    //     const y = Math.floor(n.order / 6);
    //     const x = n.order - y * 6;
    //     return { page: pages[n.pageId], x: x * 4, y: y * 6, i: n.order, w: 4, h: 6 };
    //   });
    // });

    const log = (a, b, c) => {
      console.log(a, b, c);
    };

    return { log, documentNotes, colIndex };
  },
  // methods: {
  //   ...mapActions('pages', ['updateNoteGrid']),
  //   updateGrid(newData) {
  //     console.log('update grid', newData);
  //     newData.forEach(data => {
  //       const note = this.page.pageNotes[data.noteId];
  //       const oldData = note ? note.gridData : false;
  //       console.log(data, oldData);
  //       if (
  //         !oldData ||
  //         oldData.x != data.x ||
  //         oldData.y != data.y ||
  //         oldData.h != data.h ||
  //         oldData.w != data.w
  //       ) {
  //         console.log('update db');
  //         const gridData = { ...data };
  //         delete gridData.page;
  //         delete gridData.noteId;
  //         this.updateNoteGrid({ pageId: this.page.id, noteId: data.noteId, gridData });
  //       } else {
  //         return;
  //       }
  //     });
  //   }
  // },
  data: function() {
    return {
      layout: [
        { x: 0, y: 0, w: 2, h: 2, i: '0' },
        { x: 2, y: 0, w: 2, h: 4, i: '1' },
        { x: 4, y: 0, w: 2, h: 5, i: '2' },
        { x: 6, y: 0, w: 2, h: 3, i: '3' },
        { x: 8, y: 0, w: 2, h: 3, i: '4' },
        { x: 10, y: 0, w: 2, h: 3, i: '5' },
        { x: 0, y: 5, w: 2, h: 5, i: '6' },
        { x: 2, y: 5, w: 2, h: 5, i: '7' },
        { x: 4, y: 5, w: 2, h: 5, i: '8' },
        { x: 6, y: 3, w: 2, h: 4, i: '9' },
        { x: 8, y: 4, w: 2, h: 4, i: '10' },
        { x: 10, y: 4, w: 2, h: 4, i: '11' },
        { x: 0, y: 10, w: 2, h: 5, i: '12' },
        { x: 2, y: 10, w: 2, h: 5, i: '13' },
        { x: 4, y: 8, w: 2, h: 4, i: '14' },
        { x: 6, y: 8, w: 2, h: 4, i: '15' },
        { x: 8, y: 10, w: 2, h: 5, i: '16' },
        { x: 10, y: 4, w: 2, h: 2, i: '17' },
        { x: 0, y: 9, w: 2, h: 3, i: '18' },
        { x: 2, y: 6, w: 2, h: 2, i: '19' }
      ]
    };
  }
};
</script>

<style>
.vue-grid-layout {
  background: #eee;
  width: 100%;
}
.vue-grid-item:not(.vue-grid-placeholder) {
  /* background: #ccc;
    border: 1px solid black; */
  overflow-y: auto;
}
.vue-grid-item .resizing {
  opacity: 0.9;
}
.vue-grid-item .static {
  background: #cce;
}
.vue-grid-item .text {
  font-size: 24px;
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 100%;
}
.vue-grid-item .no-drag {
  height: 100%;
  width: 100%;
}
.vue-grid-item .minMax {
  font-size: 12px;
}
.vue-grid-item .add {
  cursor: pointer;
}
.vue-draggable-handle {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 0;
  left: 0;
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>")
    no-repeat;
  background-position: bottom right;
  padding: 0 8px 8px 0;
  background-repeat: no-repeat;
  background-origin: content-box;
  box-sizing: border-box;
  cursor: pointer;
}
</style>
